import { Injectable } from '@angular/core';
import { BlockUiComponent } from './block-ui.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class BlockUiService {
    private popup!: MatDialogRef<BlockUiComponent>;

    constructor(private matDialog: MatDialog) {}

    open(): void {
        this.popup = this.matDialog.open(BlockUiComponent, { disableClose: true });
    }

    close(): void {
        if (this.popup) {
            this.popup.close();
        }
    }
}
